<template>
  <a v-show="window.history.length > 0" class="back" href="#" @click.prevent="$router.go(-1)">
    <span class="material-icons">arrow_back</span>
  </a>
</template>

<script>
export default {
  name: "Back",
  data() {
    return {
      window,
    };
  },
};
</script>

<style scoped lang="scss">
.back {
  font-size: 30px;
  padding-left: 13px;
  color: #373737 !important;
  display: none;

  @media (display-mode: standalone) {
    display: flex;
  }
}
</style>
